import { FC } from 'react';
import { useIntl } from 'react-intl';

import { HeaderCell } from '../../HeaderCell';
export interface HeaderProps {
  showCutOff: boolean;
}

export const Header: FC<HeaderProps> = ({ showCutOff }) => {
  const { formatMessage } = useIntl();

  if (!showCutOff) {
    return null;
  }

  return (
    <HeaderCell className="px-0">
      <div className="d-flex flex-column">
        <label htmlFor="CutOff" className="fs-6 mb-2 mt-2 ps-2">
          {formatMessage({
            id: 'quote.underlyingsGrid.header.cutoff',
          })}
        </label>
      </div>
    </HeaderCell>
  );
};
